import qs from 'qs';
import url from 'url';

const ADTAG_KEY = '_dbtag';

// 获取tag
const getADTag = (search: string): string => {
  if (!search) {
    return '';
  }
  const params: any = qs.parse(search, { ignoreQueryPrefix: true });
  return params[ADTAG_KEY] || '';
}

// 在路径中添加tag
const setADTagToUrl = (path: string): string => {
  const urlInfo = url.parse(path, true);
  let { protocol, host, pathname, query, hash } = urlInfo;
  if (query?.[ADTAG_KEY]) {
    return path;
  } else {
    query = {
      ...query,
      [ADTAG_KEY]: _dbtag
    }
    return url.format({
      protocol,
      host,
      pathname,
      query,
      hash
    });
  }
}

const _dbtag = getADTag(location.search);

// 劫持history
const hack = (type: string) => {
  const origin = (window as any).history[type];
  if (typeof origin !== 'function') {
    return false;
  }
  return function () {
    if (_dbtag) {
      arguments[2] = setADTagToUrl(arguments[2]);
    }
    // @ts-ignore
    const res = origin.apply(this, arguments);
    // const event = new Event(type);
    // window.dispatchEvent(event);
    return res;
  };
}

export const useTag = ():void => {
  history.pushState = hack('pushState') || history.pushState;
  history.replaceState = hack('replaceState') || history.replaceState;
}
